import axios from 'axios'

export default () => {
  return new Promise((resolve, reject) => {
    axios('https://ipapi.co/json/')
      .then(response => resolve(response.data))
      .catch(reject)
  })
}
